import React from "react";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";

const SwitchConNInput = ({ field, onChange }) => {

  const handleChange = (nome ,indice, val) => {
    const aggiornoElementoArray = { ...field.valoriInput[indice], quantita: val, totale: field.valoriInput[indice].prezzo * val}
    const result = field.valoriInput.map((item, ind) => (ind === indice ? { ...item[indice], ...aggiornoElementoArray } : item))

    const aggiornoValore = {
      ...field,
      valoriInput: result
    }
    
    const sommaPrezzi=  aggiornoValore.valoriInput.reduce((accumulator, currentValue) => accumulator + (currentValue.totale || 0) ,0,);
    const aggiornoQuantita = {
      ...aggiornoValore,
      prezzoFinale: sommaPrezzi
    }

    onChange(aggiornoQuantita)
  }

  return (
    <>
      <div className="field mb-4 col-12 md:col-6 flex-wrap">
        <label
          htmlFor="switchID"
          className="font-medium text-900"
        >
          {field.titolo}
        </label>
        <div key={field.titolo} id={field.titolo} className="flex align-items-center flex-wrap">
          <InputSwitch
            inputId="switchID"
            checked={field.valore}
            onChange={(e) =>
              onChange({
                ...field,
                valore: e.value,
                prezzoFinale: e.value ? field.valoriInput.reduce((accumulator, currentValue) => accumulator + currentValue.totale ,0,) : 0
              })
            }
          />
          <br />
          <span className="ml-2">
            {field.descrizione} 
          </span>
        </div>
      </div>
      <div className="field mb-4 grid flex-wrap gap-2 md:gap-4 col-12 md:col-6 ">
        {field.valore && field?.valoriInput?.map((elemento, indice) => {
          return (
            <>
              <div key={elemento.descrizione} id={elemento.descrizione} className="field flex flex-column">
                {/*<label htmlFor={elemento.descrizione} className="font-medium text-900">{elemento.descrizione} ({elemento.prezzo}€/{elemento.descQuantita})</label>*/}
                <label htmlFor={elemento.descrizione} className="font-medium text-900">{elemento.descrizione} </label>
                <InputNumber
                  id={elemento.descrizione}
                  key={elemento.descrizione}
                  //prefix={elemento.descQuantita+ " "}
                  placeholder={elemento.descQuantita}
                  value={elemento.quantita}
                  onChange={(e) => handleChange( elemento.nome , indice, e.value)}
                   min="0"
                  maxFractionDigits={2}
                  locale="it-IT"
                  className="w-full md:w-14rem"
                />
              </div>
            </>
          )
        })// fine map
        }
      </div>

    </>
  )
}

export default SwitchConNInput; 